import { render, staticRenderFns } from "./Step5Reward.vue?vue&type=template&id=c663bac0&scoped=true"
import script from "./Step5Reward.vue?vue&type=script&lang=js"
export * from "./Step5Reward.vue?vue&type=script&lang=js"
import style0 from "./Step5Reward.vue?vue&type=style&index=0&id=c663bac0&prod&lang=css"
import style1 from "./Step5Reward.vue?vue&type=style&index=1&id=c663bac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c663bac0",
  null
  
)

export default component.exports